import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';
import { fontFamily, fontSize } from '../../../../../constants/text';
import { colors } from '../../../../../constants/colors';
import Warning from '@material-ui/icons/Warning';
import { FadeIn } from '../../../../../core/util/commonCssAnimations';
import { dateHasOpenHours } from '../../../../../core/util/location';
import { getRelativeDayName, isDateToday } from '../../../../../core/util/date';
import { hasSlotsAvailable } from '../../../../../core/location/slots';
import {
  BOOK_MODULE_NO_MORE_ONLINE_VISITS_ALTERNATIVES_COPY,
  shouldShowFeature,
} from '../../../util/customization';

const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 14px;
`;

const StyledWarning = styled(Warning)`
  color: ${colors.peaches};
  font-size: 17px;
  margin-right: 6px;
`;

const Title = styled.div`
  color: ${colors.peaches};
  font-family: ${fontFamily.bold};
  font-size: ${fontSize.mediumSmall};
  letter-spacing: -0.27px;
  line-height: 18px;
`;
const Text = styled.div`
  color: ${colors.blueMonday};
  font-family: ${fontFamily.book};
  font-size: ${fontSize.mediumSmall};
  letter-spacing: -0.25px;
  line-height: 20px;
  text-align: center;
`;

const Container = styled.div`
  animation: ${FadeIn} 300ms linear;
  padding-left: 5%;
  padding-right: 5%;
`;

class NoSlotsLeft extends PureComponent {
  constructor(props) {
    super(props);
    this.showAlternativeOptionsCopy = shouldShowFeature(
      BOOK_MODULE_NO_MORE_ONLINE_VISITS_ALTERNATIVES_COPY,
      this.props.location
    );
  }

  shouldShowRecommendationForTomorrow = () =>
    // Only show second part of the copy if looking at today (selectedDate) and
    // Tomorrow(nextDate) is open with slots available
    isDateToday(this.props.selectedDate, this.props.location.timeZone) &&
    hasSlotsAvailable(this.props.nextDateSlots) &&
    dateHasOpenHours(this.props.location, this.props.nextDate);

  render() {
    const {
      selectedDate,
      location: { timeZone },
    } = this.props;
    const dayString = getRelativeDayName(selectedDate, timeZone).toLowerCase();

    return (
      <Container>
        <TitleContainer>
          <StyledWarning />
          <Title>No Online Visit Times Left</Title>
        </TitleContainer>
        <Text>
          Online visits are fully booked {dayString}.
          {this.showAlternativeOptionsCopy && (
            <Fragment>
              You can still walk-in to the clinic
              {this.shouldShowRecommendationForTomorrow() && ' or book for a visit tomorrow.'}
            </Fragment>
          )}
        </Text>
      </Container>
    );
  }
}

NoSlotsLeft.propTypes = {
  selectedDate: PropTypes.object,
  location: PropTypes.object,
  nextDateSlots: PropTypes.array,
  nextDate: PropTypes.object,
};

export default NoSlotsLeft;
